import React from "react";
import { RiMenu2Fill } from "react-icons/ri";
import { Link, NavLink } from "react-router-dom";
import Logo from "../../assets/images/skinefit/logo.png";

const Header = () => {
  return (
    <>
      <nav className="mt-5 px-3 flex items-center gap-3  justify-between  md:hidden w-screen">
        <div className="dropdown opacity-0 dropdown-end hover:scale:105 transition">
          <div className="bg-[#917249] p-1 rounded-full" tabIndex={0}>
            <RiMenu2Fill className="cursor-pointer   text-white " />
          </div>
        </div>
        <Link to={"/"}>
          <img src={Logo} className="w-[100px] " alt="" />
          <span className="text-xs ">For your skin benefits</span>
        </Link>
        <div className="dropdown  dropdown-end hover:scale:105 transition">
          <div className="bg-[#917249] p-1 rounded-full" tabIndex={0}>
            <RiMenu2Fill className="cursor-pointer   text-white " />
          </div>

          <ul
            tabIndex={0}
            className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52 mt-5"
          >
            <li>
              <Link to={"/"} className="uppercase text-xs">
                Home
              </Link>
            </li>
            <li>
              <Link to={"/about"} className="uppercase text-xs">
                About
              </Link>
            </li>

            <li>
              <Link to={"/"} className="uppercase text-xs">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <nav className="navbar hidden md:flex justify-between w-screen px-10">
        <div className="navbar-start"></div>
        <div className="navbar-center">
          <Link to="/">
            <h1 className="text-2xl flex flex-col items-center font-extralight leading-8 tracking-widest ">
              <img src={Logo} className="w-[220px] " alt="" />
              <span className="text-xs ">For your skin benefits</span>
            </h1>
          </Link>
        </div>
        <div className="navbar-end">
          <div className="flex gap-10">
            <NavLink to="/" className="nav-link">
              Home
            </NavLink>
            <NavLink to={"/about"} className="nav-link">
              About
            </NavLink>

            <NavLink to="/" className="nav-link">
              Contact
            </NavLink>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
